import { IDropdownProps } from 'legacy/lut/library/dropdown'
import React from 'react'

import { getFormatDate } from 'core/classes/helpers/DateHelper'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import {
  OnboardingDatePicker,
  OnboardingDropdown,
  OnboardingInput,
} from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'
import { usePartnerShip } from '../usePartnerShip'

import { IPartnerShipNA, IPartnerShipNaCrud } from './types'

interface IProps {
  onChange: (field: string, number?: boolean) => (value: string | number) => void
  crud: IPartnerShipNaCrud
  item: IPartnerShipNA
  writeAudience: IObjectAny
  isManuallySubmitted: boolean
  disabled?: boolean
}

export const OnlineAcceptanceNa = ({
  onChange,
  crud,
  item,
  writeAudience,
  isManuallySubmitted,
  disabled,
}: IProps) => {
  const isDisabledOrIsManuallySubmitted = disabled || !isManuallySubmitted
  const { activeSource } = usePartnerShip()

  return (
    <div>
      <div className={styles.text__title}>
        Online T{`&`}Cs Acceptance
        <div className={styles.text__rule}>{`(Applies only to Online applications)`}</div>
      </div>
      <OnboardingDropdown
        margin={'md'}
        label={'Accepted Online By User'}
        source={crud.OnlineByUser}
        value={item.OnlineByUser || ''}
        caption={'label'}
        onChange={onChange('OnlineByUser')}
        disabled={isDisabledOrIsManuallySubmitted}
      />
      <OnboardingInput
        margin={'md'}
        label="Accepted Online By Name"
        value={item.OnlineByName}
        onChange={onChange('OnlineByName')}
        disabled={true}
      />
      <OnboardingInput
        margin={'md'}
        label={'Accepted Online By Email ID'}
        value={item.OnlineByEmailID}
        onChange={onChange('OnlineByEmailID')}
        disabled={true}
      />
      <OnboardingDatePicker
        mode={'single'}
        onChange={(value) => {
          let formattedDate = ''
          if (value) {
            formattedDate = getFormatDate(value, 'custom', 'YYYY-MM-DD HH:mm:ss') || ''
          }
          onChange('AcceptanceDate')(formattedDate)
        }}
        label={'Acceptance Date'}
        value={item.AcceptanceDate ? new Date(item.AcceptanceDate) : undefined}
        disabled={isDisabledOrIsManuallySubmitted}
        margin={'md'}
      />
      <VisualAudienceExtended<IDropdownProps>
        component={OnboardingDropdown}
        write={writeAudience}
        source={activeSource}
        caption={'value'}
        label={`Is user who applied inactive?`}
        value={item && item.IsInactiveUser !== undefined ? `${+!!item.IsInactiveUser}` : ''}
        margin={'md'}
        onChange={onChange('IsInactiveUser', true)}
        disabled={disabled}
      />
    </div>
  )
}
